import { PageShell } from "@/components/site/PageShell";
import { Reveal, SectionLabel } from "@/components/site/Reveal";
import { MENU } from "@/data/zoneDetails";

export default function MenuPage() {
  return (
    <PageShell testId="menu-page">
      <section className="relative pt-36 pb-16 overflow-hidden">
        <img src="/img/zones/dining.jpg" alt="Friends dining at ZoopUp" className="absolute inset-0 w-full h-full object-cover opacity-30" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#07080E]/40 to-[#07080E]" />
        <div className="relative max-w-[1400px] mx-auto px-5 md:px-10">
          <SectionLabel color="text-[#FF2A85]">Food & drinks</SectionLabel>
          <h1 className="font-display font-black uppercase text-5xl sm:text-6xl lg:text-7xl leading-[0.95]">The<br /><span className="text-[#FFEF00]">Zoop menu.</span></h1>
          <p className="mt-6 text-slate-300 max-w-lg" data-testid="menu-note">Sample menu. Final dishes and prices for each centre are coming soon.</p>
        </div>
      </section>
      <section className="pb-24 max-w-[1400px] mx-auto px-5 md:px-10 grid md:grid-cols-2 gap-x-14 gap-y-14">
        {MENU.map((cat, ci) => (
          <Reveal key={cat.title} delay={(ci % 2) * 0.08}>
            <div data-testid={`menu-category-${ci}`}>
              <div className="flex items-baseline gap-4 border-b-2 border-[#FFEF00] pb-3">
                <span className="font-mono text-xs text-[#14C3F7]">0{ci + 1}</span>
                <h2 className="font-display font-extrabold text-2xl md:text-3xl uppercase">{cat.title}</h2>
              </div>
              <ul>
                {cat.items.map(([name, desc]) => (
                  <li key={name} className="group flex items-start justify-between gap-4 py-4 border-b border-white/10">
                    <div>
                      <p className="font-display font-semibold text-lg group-hover:text-[#FFEF00] transition-colors">{name}</p>
                      <p className="text-sm text-slate-400">{desc}</p>
                    </div>
                    <span className="font-mono text-sm text-slate-300 shrink-0">[₹ price]</span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        ))}
      </section>
    </PageShell>
  );
}
